export const INELIGIBILITY_REASONS_MAP = {
    EEI01: {
        reason: 'eligibility_results.ineligibility.reasons.EEI01',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI02: {
        reason: 'eligibility_results.ineligibility.reasons.EEI02',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI04: {
        reason: 'eligibility_results.ineligibility.reasons.EEI04',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI05: {
        reason: 'eligibility_results.ineligibility.reasons.EEI05',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI06: {
        reason: 'eligibility_results.ineligibility.reasons.EEI06',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI07: {
        reason: 'eligibility_results.ineligibility.reasons.EEI07',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI08: {
        reason: 'eligibility_results.ineligibility.reasons.EEI08',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI09: {
        reason: 'eligibility_results.ineligibility.reasons.EEI09',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI10: {
        reason: 'eligibility_results.ineligibility.reasons.EEI10',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI11: {
        reason: 'eligibility_results.ineligibility.reasons.EEI11',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI12: {
        reason: 'eligibility_results.ineligibility.reasons.EEI12',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI15: {
        reason: 'eligibility_results.ineligibility.reasons.EEI15',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI17: {
        reason: 'eligibility_results.ineligibility.reasons.EEI17',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI18: {
        reason: 'eligibility_results.ineligibility.reasons.EEI18',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI19: {
        reason: 'eligibility_results.ineligibility.reasons.EEI19',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI20: {
        reason: 'eligibility_results.ineligibility.reasons.EEI20',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI21: {
        reason: 'eligibility_results.ineligibility.reasons.EEI21',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI23: {
        reason: 'eligibility_results.ineligibility.reasons.EEI23',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI24: {
        reason: 'eligibility_results.ineligibility.reasons.EEI24',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI25: {
        reason: 'eligibility_results.ineligibility.reasons.EEI25',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI26: {
        reason: 'eligibility_results.ineligibility.reasons.EEI26',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI27: {
        reason: 'eligibility_results.ineligibility.reasons.EEI27',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI28: {
        reason: 'eligibility_results.ineligibility.reasons.EEI28',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI39: {
        reason: 'eligibility_results.ineligibility.reasons.EEI39',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI40: {
        reason: 'eligibility_results.ineligibility.reasons.EEI40',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI29: {
        reason: 'eligibility_results.ineligibility.reasons.EEI29',
        program: 'eligibility_results.ineligibility.program.csr',
    },
    EEI30: {
        reason: 'eligibility_results.ineligibility.reasons.EEI30',
        program: 'eligibility_results.ineligibility.program.state_subsidy',
    },
    EEI31: {
        reason: 'eligibility_results.ineligibility.reasons.EEI31',
        program: 'eligibility_results.ineligibility.program.state_subsidy',
    },
    EEI38: {
        reason: 'eligibility_results.ineligibility.reasons.EEI38',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI42: {
        reason: 'eligibility_results.ineligibility.reasons.EEI42',
        program: 'eligibility_results.ineligibility.program.qhp',
    },
    EEI44: {
        reason: 'eligibility_results.ineligibility.reasons.EEI44',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI45: {
        reason: 'eligibility_results.ineligibility.reasons.EEI45',
        program: 'eligibility_results.ineligibility.program.aptc',
    },
    EEI102: {
        reason: 'eligibility_results.ineligibility.reasons.EEI102',
        program: 'eligibility_results.ineligibility.program.csr',
    },
    EEI103: {
        reason: 'eligibility_results.ineligibility.reasons.EEI103',
        program: 'eligibility_results.ineligibility.program.csr',
    },
};